module.exports = __webpack_public_path__ + "img/dr.edda0185.png";